// extracted by mini-css-extract-plugin
export default {"signature-label":"styles_signature-label__Szl8N","signature-label__content":"styles_signature-label__content__uhIhn"};